import { createContext } from 'react';

import User from '~interfaces/user';

export interface UserContextValue {
	isLoading: boolean;
	user: User | undefined;
}

const UserContext = createContext<UserContextValue>({
	isLoading: false,
	user: undefined,
});

export default UserContext;
